import { render, staticRenderFns } from "./InsectMonitor.vue?vue&type=template&id=f842909a&scoped=true&"
import script from "./InsectMonitor.vue?vue&type=script&lang=ts&"
export * from "./InsectMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./InsectMonitor.vue?vue&type=style&index=0&id=f842909a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f842909a",
  null
  
)

export default component.exports